import { getApiBaseUrl } from "../api/baseUrl"
import { throwIfRateLimited } from "../api/rateLimit"
import type { AccessDecision } from "./config"

export async function fetchRemoteAccessDecision(
  sessionToken: string,
  signal?: AbortSignal,
): Promise<AccessDecision> {
  const baseUrl = getApiBaseUrl()
  if (!baseUrl) {
    throw new Error(
      "Remote access check is unavailable because no worker is configured.",
    )
  }

  const response = await fetch(new URL("/api/auth/access", baseUrl), {
    headers: {
      Authorization: `Bearer ${sessionToken}`,
    },
    signal,
  })

  throwIfRateLimited(response)

  if (!response.ok) {
    const message = await response.text()
    throw new Error(message || "Access check failed.")
  }

  const body = (await response.json()) as { access: AccessDecision }
  return body.access
}
